export enum MeasuringUnit {
  Percent = 'percent',
  Bps = 'bps',
  Dps = 'dps',
  Pips = 'pips',
  Cash = 'cash',
}
